import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { PassportLogo } from "@/components/Reveal";
import SupportChat from "@/components/SupportChat";
import { useTranslation } from "react-i18next";

export default function Support() {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen grain" data-testid="support-page">
            <header className="sticky top-0 z-40 glass border-b" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
                <div className="max-w-[900px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
                    <Link to="/app" className="flex items-center gap-3">
                        <ArrowLeft size={16} color="#D4AF37" />
                        <PassportLogo size={26} />
                        <div className="hidden sm:block leading-none">
                            <div className="font-serif text-base text-white">{t("support.passportSupport")}</div>
                            <div className="text-[9px] tracking-[0.3em] uppercase" style={{ color: "var(--gold)" }}>{t("support.managerAi")}</div>
                        </div>
                    </Link>
                </div>
            </header>
            <div className="max-w-[900px] mx-auto px-6 md:px-10 py-10">
                <div className="overline mb-2" style={{ color: "var(--gold)" }}>{t("support.overline")}</div>
                <h1 className="font-serif text-4xl md:text-5xl text-white leading-tight tracking-tight">{t("support.title")}</h1>
                <p className="text-white/60 text-base mt-3 max-w-lg">
                    {t("support.description")}
                </p>
                <div className="mt-8">
                    <SupportChat variant="page" />
                </div>
            </div>
        </div>
    );
}
